import * as yup from "yup";

// Policy Autocomplete Address
const MAILING_ADDRESS_REQUIRED = "Please ensure a valid address is selected";
const MAILING_MIN_LENGTH = 10;
const MAILING_MIN_LENGTH_MESSAGE = `Mailing address must be at least ${MAILING_MIN_LENGTH} characters`;

//* Manual entry
const ADDRESS_LEVEL_NUMBER_MAX_LENGTH = 10;
const ADDRESS_LEVEL_NUMBER_MAX_LENGTH_MESSAGE = `Must be less than ${ADDRESS_LEVEL_NUMBER_MAX_LENGTH} characters`;

const ADDRESS_UNIT_NUMBER_MAX_LENGTH = 10;
const ADDRESS_UNIT_NUMBER_MAX_LENGTH_MESSAGE = `Must be less than ${ADDRESS_UNIT_NUMBER_MAX_LENGTH} characters`;

const ADDRESS_STREET_NUMBER_REQUIRED = "Street number is required";
const ADDRESS_STREET_NUMBER_MAX_LENGTH = 10;
const ADDRESS_STREET_NUMBER_MAX_LENGTH_MESSAGE = `Must be less than ${ADDRESS_STREET_NUMBER_MAX_LENGTH} characters`;

const ADDRESS_STREET_NUMBER_TYPE_REQUIRED = "Street number type is required";

const ADDRESS_STREET_NAME_REQUIRED = "Street name is required";
const ADDRESS_STREET_NAME_MAX_LENGTH = 40;
const ADDRESS_STREET_NAME_MAX_LENGTH_MESSAGE = `Must be less than ${ADDRESS_STREET_NAME_MAX_LENGTH} characters`;

const ADDRESS_STREET_NAME_TYPE_REQUIRED = "Street name type is required";
const ADDRESS_POSTCODE_SUBURB_REQUIRED = "Postcode and Suburb is required";
// const ADDRESS_STATE_REQUIRED = "State is required";
// const ADDRESS_SUBURB_REQUIRED = "Suburb is required";

//*
const RESIDENTIAL_ADDRESS_VERIFY_REQUIRED = "Please verify residential address";

//* Email
const EMAIL_REQUIRED = "Email is required";
const EMAIL_NOT_VALID = "You've entered an invalid email address";
const EMAIL_MAX_LENGTH = 40;
const EMAIL_MAX_LENGTH_MESSAGE = `Email address can only be up to ${EMAIL_MAX_LENGTH} characters`;
const EMAIL_TRIM = "Email address cannot contain spaces";

//* Contact Number
const CONTACT_NUMBER_REQUIRED = "Mobile number is required";
const CONTACT_NUMBER_NOT_VALID = "You've entered an invalid mobile number";
const CONTACT_NUMBER_STARTING_WITH = "Mobile number must start with 04";
const CONTACT_NUMBER_TRIM = "Mobile number cannot contain spaces";

//** Rules */
//** If the Manual Policy Address is hidden, validate the autocomplete Address */
//** If the Manual Policy Address is shown, validate the Manual Address */

//** If the Residential Address is not the same as the Policy Address */
//** Validate either the autocomplete Address or Manual Address*/

function startsOrEndsWithWhitespace(str) {
	return /^\s|\s$/.test(str);
}

const buildPaymentPolicyMailingAddressDetails = (
	addressType = "policyMailingAddress"
) => {
	return {
		[`${addressType}Full`]: yup
			.mixed()
			.when("$isPolicyMailingAddressAutoComplete", {
				is: true,
				then: yup
					.mixed()
					.strict()
					.test(
						"is-policy-mailing-address-object",
						MAILING_ADDRESS_REQUIRED,
						function (value) {
							if (
								(typeof value === "object" ||
									(typeof value === "string" &&
										startsOrEndsWithWhitespace(value) === false)) &&
								value
							) {
								return true;
							}
							return this.createError({
								path: `${addressType}Full`,
								message: MAILING_ADDRESS_REQUIRED,
							});
						}
					),
				otherwise: yup.mixed().notRequired(),
			}),
		[`${addressType}LevelNumber`]: yup
			.string()
			.when("$isPolicyMailingAddressAutoComplete", {
				is: false,
				then: yup
					.string()
					.optional()
					.max(
						ADDRESS_LEVEL_NUMBER_MAX_LENGTH,
						ADDRESS_LEVEL_NUMBER_MAX_LENGTH_MESSAGE
					),
				otherwise: yup.string().nullable().notRequired(),
			}),
		[`${addressType}UnitNumber`]: yup
			.string()
			.when("$isPolicyMailingAddressAutoComplete", {
				is: false,
				then: yup
					.string()
					.optional()
					.max(
						ADDRESS_UNIT_NUMBER_MAX_LENGTH,
						ADDRESS_UNIT_NUMBER_MAX_LENGTH_MESSAGE
					),
				otherwise: yup.string().nullable().notRequired(),
			}),
		[`${addressType}StreetNumber`]: yup
			.string()
			.when("$isPolicyMailingAddressAutoComplete", {
				is: false,
				then: yup
					.string()
					.required(ADDRESS_STREET_NUMBER_REQUIRED)
					.max(
						ADDRESS_STREET_NUMBER_MAX_LENGTH,
						ADDRESS_STREET_NUMBER_MAX_LENGTH_MESSAGE
					),
				otherwise: yup.string().nullable().notRequired(),
			}),
		[`${addressType}StreetNumberType`]: yup
			.string()
			.when("$isPolicyMailingAddressAutoComplete", {
				is: false,
				then: yup.string().required(ADDRESS_STREET_NUMBER_TYPE_REQUIRED),
				otherwise: yup.string().nullable().notRequired(),
			}),
		[`${addressType}StreetName`]: yup
			.string()
			.when("$isPolicyMailingAddressAutoComplete", {
				is: false,
				then: yup
					.string()
					.required(ADDRESS_STREET_NAME_REQUIRED)
					.max(
						ADDRESS_STREET_NAME_MAX_LENGTH,
						ADDRESS_STREET_NAME_MAX_LENGTH_MESSAGE
					),
				otherwise: yup.string().nullable().notRequired(),
			}),

		[`${addressType}StreetNameType`]: yup
			.string()
			.when("$isPolicyMailingAddressAutoComplete", {
				is: false,
				then: yup.string().required(ADDRESS_STREET_NAME_TYPE_REQUIRED),
				otherwise: yup.string().nullable().notRequired(),
			}),

		[`${addressType}PostcodeSuburb`]: yup
			.mixed()
			.when("$isPolicyMailingAddressAutoComplete", {
				is: false,
				then: yup
					.mixed()
					.test(
						"is-postcode-object",
						ADDRESS_POSTCODE_SUBURB_REQUIRED,
						function (value) {
							if (
								(typeof value === "object" || typeof value === "string") &&
								value
							) {
								return true;
							}
							return this.createError({
								path: `${addressType}PostcodeSuburb`,
								message: ADDRESS_POSTCODE_SUBURB_REQUIRED,
							});
						}
					),
				otherwise: yup.mixed().notRequired(),
			}),
	};
};

//** Residential Address - We have multiple conditions in the when clause */
const buildPaymentResidentialMailingAddressDetails = (
	addressType = "residentialAddress"
) => {
	return {
		["bothAddressesTheSame"]: yup
			.string()
			.oneOf(["yes", "no"])
			.required(RESIDENTIAL_ADDRESS_VERIFY_REQUIRED),
		[`${addressType}Full`]: yup
			.mixed()
			.when("$isResidentialMailingAddressAutoComplete", {
				is: true,
				then: yup
					.mixed()
					.test(
						"is-policy-address-object",
						MAILING_ADDRESS_REQUIRED,
						function (value) {
							if (this.parent.bothAddressesTheSame === "yes") {
								return true;
							}
							if (
								(typeof value === "object" || typeof value === "string") &&
								value
							) {
								return true;
							}
							return this.createError({
								path: `${addressType}Full`,
								message: MAILING_ADDRESS_REQUIRED,
							});
						}
					),
				otherwise: yup.mixed().notRequired(),
			}),
		[`${addressType}LevelNumber`]: yup
			.string()
			.when("$isResidentialMailingAddressAutoComplete", {
				is: false,
				then: yup.string().when("bothAddressesTheSame", {
					is: "no",
					then: yup
						.string()
						.optional()
						.max(
							ADDRESS_LEVEL_NUMBER_MAX_LENGTH,
							ADDRESS_LEVEL_NUMBER_MAX_LENGTH_MESSAGE
						),
					otherwise: yup.string().nullable().notRequired(),
				}),
				otherwise: yup.string().nullable().notRequired(),
			}),
		[`${addressType}UnitNumber`]: yup
			.string()
			.when("$isResidentialMailingAddressAutoComplete", {
				is: false,
				then: yup.string().when("bothAddressesTheSame", {
					is: "no",
					then: yup
						.string()
						.optional()
						.max(
							ADDRESS_UNIT_NUMBER_MAX_LENGTH,
							ADDRESS_UNIT_NUMBER_MAX_LENGTH_MESSAGE
						),
					otherwise: yup.string().nullable().notRequired(),
				}),
				otherwise: yup.string().nullable().notRequired(),
			}),
		[`${addressType}StreetNumber`]: yup
			.string()
			.when("$isResidentialMailingAddressAutoComplete", {
				is: false,
				then: yup.string().when("bothAddressesTheSame", {
					is: "no",
					then: yup
						.string()
						.required(ADDRESS_STREET_NUMBER_REQUIRED)
						.max(
							ADDRESS_STREET_NUMBER_MAX_LENGTH,
							ADDRESS_STREET_NUMBER_MAX_LENGTH_MESSAGE
						),
					otherwise: yup.string().nullable().notRequired(),
				}),
				otherwise: yup.string().nullable().notRequired(),
			}),
		[`${addressType}StreetNumberType`]: yup
			.string()
			.when("$isResidentialMailingAddressAutoComplete", {
				is: false,
				then: yup.string().when("bothAddressesTheSame", {
					is: "no",
					then: yup.string().required(ADDRESS_STREET_NUMBER_TYPE_REQUIRED),
					otherwise: yup.string().nullable().notRequired(),
				}),
				otherwise: yup.string().nullable().notRequired(),
			}),
		[`${addressType}StreetName`]: yup
			.string()
			.when("$isResidentialMailingAddressAutoComplete", {
				is: false,
				then: yup.string().when("bothAddressesTheSame", {
					is: "no",
					then: yup
						.string()
						.required(ADDRESS_STREET_NAME_REQUIRED)
						.max(
							ADDRESS_STREET_NAME_MAX_LENGTH,
							ADDRESS_STREET_NAME_MAX_LENGTH_MESSAGE
						),
					otherwise: yup.string().nullable().notRequired(),
				}),
				otherwise: yup.string().nullable().notRequired(),
			}),
		[`${addressType}StreetNameType`]: yup
			.string()
			.when("$isResidentialMailingAddressAutoComplete", {
				is: false,
				then: yup.string().when("bothAddressesTheSame", {
					is: "no",
					then: yup.string().required(ADDRESS_STREET_NAME_TYPE_REQUIRED),
					otherwise: yup.string().nullable().notRequired(),
				}),
				otherwise: yup.string().nullable().notRequired(),
			}),
		[`${addressType}PostcodeSuburb`]: yup
			.mixed()
			.when("$isResidentialMailingAddressAutoComplete", {
				is: false,
				then: yup
					.mixed()
					.test(
						"is-postal-postcode-object",
						ADDRESS_POSTCODE_SUBURB_REQUIRED,
						function (value) {
							if (this.parent.bothAddressesTheSame === "yes") {
								return true;
							}
							if (
								(typeof value === "object" || typeof value === "string") &&
								value
							) {
								return true;
							}
							return this.createError({
								path: `${addressType}PostcodeSuburb`,
								message: ADDRESS_POSTCODE_SUBURB_REQUIRED,
							});
						}
					),
				otherwise: yup.mixed().notRequired(),
			}),
	};
};

//* Only personOne has email and contact number details.
const buildPaymentContactDetails = () => {
	return {
		[`personOne_emailAddress`]: yup
			.string()
			.strict(true)
			.trim(EMAIL_TRIM)
			.email(EMAIL_NOT_VALID)
			.max(EMAIL_MAX_LENGTH, EMAIL_MAX_LENGTH_MESSAGE)
			.required(EMAIL_REQUIRED),
		[`personOne_contactNumber`]: yup
			.string()
			.strict(true)
			.trim(CONTACT_NUMBER_TRIM)
			.phone("AU", CONTACT_NUMBER_NOT_VALID)
			.required(CONTACT_NUMBER_REQUIRED)
			.test("mobile_number", CONTACT_NUMBER_STARTING_WITH, function (value) {
				return value?.slice(0, 2) === "04";
			}),
		[`policyDocumentRequestType`]: yup
			.string()
			.when("$isContactCenterApplication", {
				is: true,
				then: yup.string().optional().required("THIS IS REQUIRED"),
				otherwise: yup.string().nullable().notRequired(),
			}),
	};
};

export function schemaPaymentContactDetails() {
	return yup
		.object()
		.shape({
			...buildPaymentPolicyMailingAddressDetails(),
			...buildPaymentResidentialMailingAddressDetails(),
			...buildPaymentContactDetails(),
		})
		.required();
}
